import Swiper from "swiper";
import {Autoplay} from "swiper";
import {BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG} from "../globals";

const SLIDES_PER_VIEW_SM = 4;
const SLIDES_PER_VIEW_MD = 5;
const SLIDES_PER_VIEW_LG = 'auto';

export default class SliderTypo {
	
	constructor(sliderContainer) {
		
		if (sliderContainer === null ) return;

		this.swiperDelay = sliderContainer.getAttribute('data-slider-delay');
		this.swiperDirection = sliderContainer.getAttribute('data-slider-direction');
		this.swiperElement = sliderContainer.querySelector('.swiper');
		this.isReversed = this.swiperDirection == 'reversed';
				
		/** @var {SwiperOptions} */
		const config = {
			modules: [Autoplay],
			slidesPerView: 2,			
			breakpoints: {
				[BREAKPOINT_SM]: {
					slidesPerView: SLIDES_PER_VIEW_SM,
				},
				[BREAKPOINT_MD]: {
					slidesPerView: SLIDES_PER_VIEW_MD,
				},
				[BREAKPOINT_LG]: {  
					slidesPerView: SLIDES_PER_VIEW_LG,
				}
			},
			grabCursor: true,
			initialSlide: this.isReversed ? Number.MAX_SAFE_INTEGER : 0,
			speed: 1000,
			autoplay: {
				delay: this.swiperDelay * 1000, // in milliseconds
				disableOnInteraction: false,
				reverseDirection: this.isReversed,
			},
		};
		
		this.slider = new Swiper(this.swiperElement, config);

		return this;
	}

	static initAll() {
		const sliders = document.querySelectorAll('.slider-typo');
		sliders.forEach((slider, index) => {
			setTimeout(() => new SliderTypo(slider), index * 500);
		});
	}
}